module.exports = __webpack_public_path__ + "img/lovers-logo.08cc8826.svg";